import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { Contact } from '@/models/contact.model';
import { cloneDeep } from 'lodash';

interface ContactSelected extends Contact {
  isSelected: boolean;
}

interface LoadingState {
  selectedContacts: ContactSelected[];
}

export const defaultSelectedContactsState: LoadingState = {
  selectedContacts: []
};

const state: LoadingState = cloneDeep(defaultSelectedContactsState);

const mutations: MutationTree<LoadingState> = {
  ADD_SELECTED_CONTACTS(returnedState: LoadingState, payload: []): void {
    returnedState.selectedContacts = payload.map(
      (elem: ContactSelected): ContactSelected => {
        return { ...elem, isSelected: true };
      }
    );
  },
  ADD_SELECTED_CONTACTS_BATCH(returnedState: LoadingState, payload: ContactSelected[]): void {
    returnedState.selectedContacts = payload;
  },
  REMOVE_SELECTED_CONTACT(returnedState: LoadingState, payload: string): void {
    returnedState.selectedContacts = returnedState.selectedContacts.filter(
      (contact: Contact): boolean => contact.id !== payload
    );
  },
  EMPTY_SELECTED_CONTACTS(returnedState: LoadingState): void {
    returnedState.selectedContacts.splice(0, returnedState.selectedContacts.length);
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addSelectedContacts: ({ commit }: ActionContext<LoadingState, {}>, payload: ContactSelected): void => {
    commit('ADD_SELECTED_CONTACTS', payload);
  },
  addSelectedContactsBatch: ({ commit }: ActionContext<LoadingState, {}>, payload: ContactSelected[]): void => {
    commit('ADD_SELECTED_CONTACTS_BATCH', payload);
  },
  removeSelectedContact: ({ commit }: ActionContext<LoadingState, {}>, payload: string): void => {
    commit('REMOVE_SELECTED_CONTACT', payload);
  },
  emptySelectedContacts: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('EMPTY_SELECTED_CONTACTS');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  selectedContacts: (returnedState: LoadingState): ContactSelected[] => {
    return returnedState.selectedContacts;
  },
  selectedContactsIds: (returnedState: LoadingState): string[] => {
    return returnedState.selectedContacts.map((value: ContactSelected): string => value.id);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
